
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/404-blog",
      function () {
        return require("private-next-pages/blog/404-blog/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/404-blog"])
      });
    }
  